import * as React from 'react';
import { Alert, TextField, Typography } from '@client/new/components/basic';
import { PrimaryButton } from '@client/new/components/button';
import { Grid } from './helpers';
import { HostingProviderSelect } from './DnsConfigInstructions';
import { useState } from 'react';
import { ConnectDomainModal } from './ConnectDomainModal';
import ReactPlayer from 'react-player';
import { colors } from '@client/new/components/colors';

type DomainFormProps = {
  isLoading: boolean;
  domain: string;
  appUrl: string;
  register: any;
  subdomain: string;
  onSubmit: () => void;
  hostingProvider: string;
  setHostingProvider: React.Dispatch<React.SetStateAction<string>>;
  errorMessage: string;
};
export function DomainForm({
  isLoading,
  domain,
  subdomain,
  appUrl,
  register,
  onSubmit,
  hostingProvider,
  setHostingProvider,
  errorMessage,
}: DomainFormProps) {
  const [showModal, setShowModal] = useState(false);

  const onConnect = () => {
    setShowModal(false);
    onSubmit();
  };
  return (
    <div>
      <form className="flex flex-col">
        <Grid>
          {/* Add tutorial column when video is ready*/}
          {/* <Column>
            <span className="font-bold text-2xl">
              Learn how to connect a custom domain
            </span>
            <ReactPlayer
              url={ 'TODO'}
              width={'100%'}
              height={'auto'}
              config={{
                file: {
                  attributes: {
                    poster: '/static/images/custom-domain-tutorial.png',
                  },
                },
              }}
              controls={true}
              playsinline
            />
          </Column> */}
          <div className="flex flex-col gap-8">
            <div>
              <span className="font-bold text-2xl">
                Select your web hosting provider
              </span>
              <Typography variant="body2" className="mb-4">
                Your web hosting provider is the place where you registered your
                domain.
              </Typography>
              <HostingProviderSelect
                value={hostingProvider}
                onChange={setHostingProvider}
              />
            </div>
            <div>
              <Typography variant="h4" className="mb-4">
                Enter your domain
              </Typography>
              <TextField
                label="Enter your domain"
                {...register('domain')}
                required
                InputProps={{
                  startAdornment: 'https://',
                  placeholder: 'myplaybookapp.com',
                }}
                sx={{
                  marginBottom: '24px',
                  '&>label>span.MuiFormLabel-asterisk': {
                    color: colors.error100,
                  },
                  '&>label.MuiFormLabel-root': {
                    padding: '4px',
                    margin: 0,
                  },
                }}
              />
              <TextField
                label="Re-enter your domain"
                {...register('repeatDomain')}
                required
                InputProps={{
                  startAdornment: 'https://',
                  placeholder: 'myplaybookapp.com',
                }}
                sx={{
                  '&>label>span.MuiFormLabel-asterisk': {
                    color: colors.error100,
                  },
                  '&>label.MuiFormLabel-root': {
                    padding: '4px',
                    margin: 0,
                  },
                }}
              />
            </div>
            <div>
              <Typography variant="h4" className="mb-4">
                Choose your subdomain
              </Typography>
              <div>
                <TextField
                  label="Landing page subdomain"
                  {...register('subdomain', {
                    setValueAs: (value: string) => value.trim(),
                  })}
                  required
                  InputProps={{
                    endAdornment: domain ? `.${domain}` : '.myplaybookapp.com',
                    placeholder: domain.toLowerCase().includes('app')
                      ? 'join'
                      : 'app',
                    startAdornment: 'https://',
                  }}
                  sx={{
                    '&>label>span.MuiFormLabel-asterisk': {
                      color: colors.error100,
                    },
                    '&>label.MuiFormLabel-root': {
                      padding: '4px',
                      margin: 0,
                    },
                  }}
                />
              </div>
              {domain && subdomain && (
                <div className="space-y-3">
                  <Alert severity="info" className=" bg-blue-50 mt-3">
                    Your playbook landing page will be accessible at{' '}
                    <b>{appUrl}</b>
                  </Alert>
                </div>
              )}
            </div>
            {errorMessage && (
              <Alert severity="error" className="bg-red-100">
                {String(errorMessage)}
              </Alert>
            )}
            <PrimaryButton
              onClick={() => setShowModal(true)}
              isLoading={isLoading}
            >
              Connect subdomain
            </PrimaryButton>
          </div>
        </Grid>
      </form>
      <ConnectDomainModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onConfirm={onConnect}
        isSubmitting={isLoading}
        appUrl={appUrl}
      />
    </div>
  );
}
